import { render } from "./ModalDocumentUpload.vue?vue&type=template&id=35c69d50&scoped=true"
import script from "./ModalDocumentUpload.vue?vue&type=script&lang=js"
export * from "./ModalDocumentUpload.vue?vue&type=script&lang=js"

import "./ModalDocumentUpload.vue?vue&type=style&index=0&id=35c69d50&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c69d50"]])

export default __exports__